import { render, staticRenderFns } from "./SecureOptionSection.vue?vue&type=template&id=ab171212&scoped=true&"
import script from "./SecureOptionSection.vue?vue&type=script&lang=js&"
export * from "./SecureOptionSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab171212",
  null
  
)

export default component.exports